export function getMessageKey(message, fallbackIndex) {
  return (
    message?.id ||
    message?.msg_id ||
    message?.w_id ||
    message?.message_id ||
    `msg-${fallbackIndex}`
  );
}
